import { useEffect, useState } from 'react'

const DEFAULT_DEBOUNCE_DELAY = 350

export const useDebouncedValue = <T>(value: T, delay?: number): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value)
    }, delay ?? DEFAULT_DEBOUNCE_DELAY)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}
